


const clone = (obj) =>{
    return JSON.parse(JSON.stringify(obj || {}))
}

const items =
{


}

const models =
{
    get(name,arg)
    {
        if (typeof (items[name]) != "function")
            return clone(items[name])

        return clone(items[name](arg))
    },

}

export default models